import Cookies from "universal-cookie";
import axios from "axios";
import { teamAwareGet, teamAwarePost, teamAwarePut } from "../utils/teamApiHelper";

function getToken() {
    const cookies = new Cookies();
    return cookies.get("token");
}

export function createOrUpdateProject(data) {
    var url = process.env.REACT_APP_API_BASE_URL + "/project";
    return axios.post(url, data, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function getProjects(team_uuid = null) {
    // Use provided team_uuid or let teamAwareGet auto-inject current team
    var url = team_uuid 
        ? process.env.REACT_APP_API_BASE_URL + `/projects/` + team_uuid
        : process.env.REACT_APP_API_BASE_URL + `/projects/{team_uuid}`;
    return teamAwareGet(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function getProject(project_uuid) {
    var url = process.env.REACT_APP_API_BASE_URL + `/project/` + project_uuid;
    return axios.get(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

// Consolidated API call for project dashboard data (reduces 4-5 API calls to 1)
export function getProjectDashboard(project_uuid) {
    var url = process.env.REACT_APP_API_BASE_URL + `/project/${project_uuid}/dashboard`;
    return axios.get(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

// Consolidated API call for project calendar data (reduces 4 API calls to 1)
export function getProjectCalendar(project_uuid, params = {}) {
    var url = process.env.REACT_APP_API_BASE_URL + `/project/${project_uuid}/calendar`;
    return axios.get(url, { 
        params: params, // Include view, start_date, end_date parameters
        headers: { authorization: `Bearer ${getToken()}` } 
    });
}

export function getProjectDeletionInfo(project_uuid) {
    var url = process.env.REACT_APP_API_BASE_URL + `/project/${project_uuid}/deletion`;
    return axios.get(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function updateProjectDeletion(project_uuid, data) {
    var url = process.env.REACT_APP_API_BASE_URL + `/project/${project_uuid}/deletion`;
    return axios.put(url, data, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function getProjectFlowStatus(project_uuid) {
    var url = process.env.REACT_APP_API_BASE_URL + `/project/${project_uuid}/flow-status`;
    return axios.get(url, { headers: { authorization: `Bearer ${getToken()}` } });
}

export function updateProjectFlowStep(project_uuid, stepIndex, action) {
    var url = process.env.REACT_APP_API_BASE_URL + `/project/${project_uuid}/flow-step`;
    return axios.post(url, {
        step_index: stepIndex,
        action: action
    }, { headers: { authorization: `Bearer ${getToken()}` } });
}
